import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class PictureService {

  private apiURL = environment.apiURL;

  constructor() { }

  public getPicture(typeId: string, sizeId: string, pictureId: string): string {
    return this.apiURL + 'picture/' + typeId + '/' + sizeId + '/' + pictureId;
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/services/picture.service.ts